module.exports = __webpack_public_path__ + "Flag-408.71bbd78d9bfa43dc1420e36aa3c1a127.svg";